import '../scss/style.scss'

import { accordion } from './modules/accordion'
import { tabs } from './modules/tabs'
import { overlayMenu } from './modules/overlay-menu'
import { videoAutoplay } from './modules/video-autoplay'
import { pdfLinks } from './modules/pdf-links'
import { dropdown } from './modules/dropdown'

overlayMenu()

dropdown()

pdfLinks()

videoAutoplay()

accordion()

tabs()